import { Text, Stack } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import CardsList from "@/components/cardsList";
import { NETWORK_AUTOMATION_CONSTANTS } from "./constants";

const ServicesComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack spacing={6} align={"center"}>
      <CardsList
        columns={{ base: 1, sm: 2 }}
        title={NETWORK_AUTOMATION_CONSTANTS.title}
        desc={NETWORK_AUTOMATION_CONSTANTS.desc}
        list={NETWORK_AUTOMATION_CONSTANTS.list}
        spacing={{ base: 8, md: 16 }}
      />
      <Text variant={TextVariant} color="text.100">
        {NETWORK_AUTOMATION_CONSTANTS.conclusion}
      </Text>
    </Stack>
  );
};

export default ServicesComponent;
